import { render } from "./SupplierDocumentEditMenu.vue?vue&type=template&id=257b0fea&scoped=true"
import script from "./SupplierDocumentEditMenu.vue?vue&type=script&lang=js"
export * from "./SupplierDocumentEditMenu.vue?vue&type=script&lang=js"

import "./SupplierDocumentEditMenu.vue?vue&type=style&index=0&id=257b0fea&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257b0fea"]])

export default __exports__